import { render, staticRenderFns } from "./ConsumeListDialog.vue?vue&type=template&id=3963cb94&scoped=true"
import script from "./ConsumeListDialog.vue?vue&type=script&lang=js"
export * from "./ConsumeListDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsumeListDialog.vue?vue&type=style&index=0&id=3963cb94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963cb94",
  null
  
)

export default component.exports